import * as effects from 'redux-saga/effects';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { settingsActions } from '../../actions';
import { FillSettingsActionPayload } from '../../typedefs';

export function* fetchSettings() {
  try {
    yield effects.put(settingsActions.startFetching());
    const response: Response = yield effects.apply(api, api.get, [
      { endpoint: 'settings/' },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }
    const data: FillSettingsActionPayload = yield effects.call([
      response,
      'json',
    ]);
    yield effects.put(settingsActions.fillSettings(data));
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(settingsActions.stopFetching());
  }
}
